import React, { useEffect, useState, useRef } from "react";
import { makeStyles } from "@material-ui/core/styles";
import http from "../services/httpService";
import toast from "react-hot-toast";
import Typography from "@material-ui/core/Typography";
import InputLabel from "@material-ui/core/InputLabel";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { Button } from "@material-ui/core";
// import ContentCopy from "@material-ui/icons/ContentCopy";
import Grid from "@material-ui/core/Grid";
import {
  Select,
  MenuItem,
  TextField,
  RadioGroup,
  FormControl,
  FormControlLabel,
  Radio,
  Input,
} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    paddingTop: theme.spacing(2),
    textAlign: "left",
    color: theme.palette.text.primary,
  },
  submitButton: {
    marginTop: theme.spacing(5),
    marginBottom: theme.spacing(5),
  },
  gridDevider: {
    marginTop: theme.spacing(6),
    textAlign: "left",
    color: theme.palette.text.primary,
  },
  lableColor: {
    color: "#393939",
    paddingTop: "10px",
  },
  select: {
    height: 36,
    width: 235,
    // marginLeft: 25,
  },
  mobileCode: {
    height: 36,
  },
  radio: {
    "&$checked": {
      color: "#57bf74",
    },
  },

  checked: {},
}));
let disableDiscountAmount = true;
let enableCopyText = false;
let urlToCopy = "";
let clipBoard = "";

export default function CreateFranchise() {
  const [execustiveList, setExecutiveList] = useState([]);
  const [selectedExecutive, setSelectedExecutive] = useState("");
  const [hideServiceType, SetHideServiceType] = useState(true);
  const [selectedDiscountAmount, setSelectedDiscountAmount] = useState("");
  const [selectedServiceType, setSelectedServiceType] = useState("");
  const [showurl, setShowUrl] = useState(false);
  const [serviceType, setServiceType] = useState([
    {
      id: 1,
      text: "SavartX",
    },
    {
      id: 2,
      text: "Savartx3",
    },
  ]);
  const [chooseLInk, setChooseLink] = useState([]);
  const [chooseStaticLink, setChooseStaticLink] = useState([
    {
      value: 1,
      name: "FHR",
    },
    {
      value: 2,
      name: "Web-link",
    },
  ]);
  // const [chooseUserLink]
  const [filteredLInk, setFilteredLink] = useState([]);
  const [selectedChoosenLink, setSelectedChoosenLink] = useState("");
  const [selectedExecutiveLink, setSelectedExecutiveLink] = useState("");
  const classes = useStyles();
  useEffect(() => {
    executive_list();
  }, []);

  let FRANCHISE_BASE_URL =
    (window.location.href.includes("staging") ||
    window.location.href.includes("localhost"))
      ? "https://staging.savart.com"
      : "https://savart.com";
  // console.log(FRANCHISE_BASE_URL);

  const executive_list = () => {
    http
      .get("/BTLexecutives")
      .then((response) => {
        if (
          response.data &&
          response.data.Data &&
          Array.isArray(response.data.Data) &&
          response.data.Data.length > 0
        ) {
          setExecutiveList(response.data.Data);
          SetHideServiceType(response.data.role);
          setChooseLink(response.data.Data);
        } else {
          // toast.error(
          //   "Questioner Data Not Available for this investor..!",
          //   "first"
          // );
          SetHideServiceType(false);

          // history.goBack();
        }
      })
      .catch((error) => {
        // toast.error(
        //   "Questioner Data Not Available for this investor..!",
        //   "second"
        // );
        // history.goBack();
      });
  };

  const handleExecutiveChange = (e, value) => {
    setShowUrl(true);
    setSelectedExecutive(value);
    let base64franchise = "";
    let franchise64 = "";
    let data = "";
    let buff = "";
    let base64 = value.toString();
    franchise64 = new Buffer(base64);
    base64franchise = franchise64.toString("base64");
    let serviceTypebase = new Buffer(base64);
    let base64dservice = serviceTypebase.toString("base64");
    let dicountData = selectedDiscountAmount;
    let discountBuff = new Buffer(dicountData);
    let base64discount = discountBuff.toString("base64");
    data = value.toString();
    buff = new Buffer(data);
    urlToCopy = `${FRANCHISE_BASE_URL}/customer/#/login?franchise=
            ${base64franchise}&discount=${base64discount}&service_type=${base64dservice}`;

    if (
      localStorage.getItem("empRole") === "MF Manager" ||
      localStorage.getItem("empRole") === "MF Executive" ||
      localStorage.getItem("empRole") === "Franchise"
    ) {
      // alert(selectedExecutive)
      urlToCopy = `${FRANCHISE_BASE_URL}/customer/#/login?franchise=${base64franchise}&signup_from=mf`;
    } else {
      urlToCopy = `${FRANCHISE_BASE_URL}/customer/#/login?franchise=
            ${base64franchise}`;
    }
  };
  const handleServiceTypeChange = (e) => {
    setSelectedServiceType(e.target.value);
    disableDiscountAmount = false;
    enableCopyText = true;
  };
  const handleChooseLinkChange = (e) => {
    console.log(chooseLInk);
    let abcd = chooseLInk.filter((item) => {
      return item.value === e.target.value;
    });
    setFilteredLink(abcd);
  };
  const handleChooseSelectedLinkChange = (e) => {
    setSelectedChoosenLink(e.target.value);
  };
  const handleChooseExecutiveLinkChange = (e) => {
    setShowUrl(false);
    setSelectedExecutiveLink(e.target.value);
  };

  const textToCopy = () => {
    // let bufferObj = Buffer.from(base64franchise, "base64");

    // Decoding base64 into String
    // https://dev.savart.com/media/QUIZ/LP-quiz.html/
    let base64franchise = "";
    let clipBoard = "";
    let data = "";
    let buff = "";
    if (selectedExecutive === "") {
      toast.error("Please select executive list");
    } else if (enableCopyText === true) {
      if (selectedDiscountAmount === "") {
        toast.error("Please add discount amount");
      } else {
        let base64 = selectedServiceType;
        let serviceTypebase = new Buffer(base64);
        let base64dservice = serviceTypebase.toString("base64");
        let dicountData = selectedDiscountAmount;
        let discountBuff = new Buffer(dicountData);
        let base64discount = discountBuff.toString("base64");
        data = selectedExecutive.toString();
        buff = new Buffer(data);
        base64franchise = buff.toString("base64");
        urlToCopy = `${FRANCHISE_BASE_URL}/customer/#/login?franchise=
                ${base64franchise}&discount=${base64discount}&service_type=${base64dservice}`;
        clipBoard = navigator.clipboard.writeText(urlToCopy);
        toast.success("Text Copied Successfully");

        enableCopyText = false;
        setSelectedServiceType("");
        setSelectedDiscountAmount("");
        setSelectedExecutive("");
      }
    } else {
      data = selectedExecutive.toString();
      buff = new Buffer(data);
      base64franchise = buff.toString("base64");
      buff = new Buffer(data);
      base64franchise = buff.toString("base64");

      if (
        localStorage.getItem("empRole") === "MF Manager" ||
        localStorage.getItem("empRole") === "MF Executive" ||
        localStorage.getItem("empRole") === "Franchise"
      ) {
        urlToCopy = `${FRANCHISE_BASE_URL}/customer/#/login?franchise=${base64franchise}&signup_from=mf`;
      } else {
        urlToCopy = `${FRANCHISE_BASE_URL}/customer/#/login?franchise=
            ${base64franchise}`;
      }

      clipBoard = navigator.clipboard.writeText(urlToCopy);
      // let bufferObj = Buffer.from(base64franchise, "base64");

      // Decoding base64 into String
      // let string = bufferObj.toString("utf8");

      // Printing the base64 decoded string
      toast.success("Text Copied Successfully");
      enableCopyText = false;
      setSelectedExecutive("");
    }
  };

  const urlToClipboard = () => {
    let choosenLinkBase = selectedChoosenLink.toString();
    let chooseTypebase = new Buffer(choosenLinkBase);
    let base64dservice = chooseTypebase.toString("base64");
    let executiveBase = selectedExecutiveLink.toString();
    let serviceTypebase = new Buffer(executiveBase);
    let base64Excecutiveservice = serviceTypebase.toString("base64");
    // urlToCopy = `https://dev.savart.com/media/QUIZ/LP-quiz.html/?link=${base64dservice}&service_type=${base64Excecutiveservice}`;
    // clipBoard = navigator.clipboard.writeText(urlToCopy);
    setShowUrl(true);
    if (selectedChoosenLink !== 1) {
      urlToCopy = `${FRANCHISE_BASE_URL}/customer/#/login?franchise=${base64Excecutiveservice}&signup_from=weblink`;
    } else {
      urlToCopy = `${FRANCHISE_BASE_URL}/media/FHR/LP-quiz.html?executive=${base64Excecutiveservice}`;
    }
  };
  const copyTheLinkAfterShowing = () => {
    clipBoard = navigator.clipboard.writeText(urlToCopy);
    toast.success("Text Copied Successfully");
    setShowUrl(false);
  };

  return (
    <>
      <Grid
        container
        component="main"
        className="pb30"
        style={{ alignItems: "center" }}
      >
        <>
          <>
            {localStorage.getItem("empRole") === "CTO" ? (
              <>
                <Grid item xs={6} sm={3}>
                  <Typography variant="h6">
                    <InputLabel className={classes.lableColor}>
                      Link
                      {/* <span
                          style={{
                              color: "red",
                              fontSize: "1.2rem",
                              // marginLeft: "0.2rem",

                          }}
                      >
                          *
                      </span> */}
                    </InputLabel>
                  </Typography>
                  <Select
                    displayEmpty
                    labelId="statusLable"
                    id="statusSelect"
                    variant="outlined"
                    className={classes.select}
                    value={selectedChoosenLink ? selectedChoosenLink : ""}
                    onChange={handleChooseSelectedLinkChange}
                    // textToCopy
                    style={{
                      // paddingBlock: 20,
                      width: "300px",
                    }}
                  >
                    <MenuItem value="">Select</MenuItem>
                    {chooseStaticLink.map((option) => {
                      return (
                        <MenuItem value={option.value} key={option.value}>
                          {option.name}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </Grid>
                <Grid item xs={6} sm={3}>
                  <Typography variant="h6">
                    <InputLabel className={classes.lableColor}>
                      Source
                      {/* <span
                          style={{
                              color: "red",
                              fontSize: "1.2rem",
                              // marginLeft: "0.2rem",

                          }}
                      >
                          *
                      </span> */}
                    </InputLabel>
                  </Typography>
                  <Select
                    displayEmpty
                    labelId="statusLable"
                    id="statusSelect"
                    variant="outlined"
                    className={classes.select}
                    // value={selectedServiceType ? selectedServiceType : ""}
                    onChange={handleChooseLinkChange}
                    // textToCopy
                    style={{
                      // paddingBlock: 20,
                      width: "300px",
                    }}
                  >
                    <MenuItem>Select</MenuItem>
                    {chooseLInk.map((option) => {
                      return (
                        <MenuItem value={option.value} key={option.value}>
                          {option.name}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </Grid>
                {filteredLInk.length !== 0 ? (
                  <>
                    <Grid item xs={6} sm={3}>
                      <Typography variant="h6">
                        <InputLabel className={classes.lableColor}>
                          Executive
                          {/* <span
                          style={{
                              color: "red",
                              fontSize: "1.2rem",
                              // marginLeft: "0.2rem",

                          }}
                      >
                          *
                      </span> */}
                        </InputLabel>
                      </Typography>
                      <Select
                        displayEmpty
                        labelId="statusLable"
                        id="statusSelect"
                        variant="outlined"
                        className={classes.select}
                        value={
                          selectedExecutiveLink ? selectedExecutiveLink : ""
                        }
                        onChange={handleChooseExecutiveLinkChange}
                        // textToCopy
                        style={{
                          // paddingBlock: 20,
                          width: "300px",
                        }}
                      >
                        <MenuItem value="">Select</MenuItem>
                        {filteredLInk[0].options.map((option) => {
                          return (
                            <MenuItem value={option.id} key={option.id}>
                              {option.empfname}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </Grid>
                  </>
                ) : (
                  ""
                )}
              </>
            ) : (
              <>
                <Grid item xs={6} sm={3}>
                  <Typography variant="h6">
                    <InputLabel className={classes.lableColor}>
                      Choose Executive
                      <span
                        style={{
                          color: "red",
                          fontSize: "1.2rem",
                          // marginLeft: "0.2rem",
                        }}
                      >
                        *
                      </span>
                    </InputLabel>
                  </Typography>
                  <Select
                    displayEmpty
                    labelId="statusLable"
                    id="statusSelect"
                    variant="outlined"
                    className={classes.select}
                    // value={selectedExecutive ? selectedExecutive : ""}
                    value={selectedExecutive}
                    onChange={(e) => handleExecutiveChange(e, e.target.value)}
                    style={{
                      // paddingBlock: 20,
                      width: "300px",
                    }}
                  >
                    <MenuItem value="">Select</MenuItem>
                    {execustiveList.map((option) => {
                      return (
                        <MenuItem value={option.id} key={option.id}>
                          {option.empfname + " " + option.emplname}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </Grid>

                {hideServiceType === false ? (
                  <>
                    <Grid item xs={6} sm={3}>
                      <Typography variant="h6">
                        <InputLabel className={classes.lableColor}>
                          Choose Service Type
                          {/* <span
                          style={{
                              color: "red",
                              fontSize: "1.2rem",
                              // marginLeft: "0.2rem",

                          }}
                      >
                          *
                      </span> */}
                        </InputLabel>
                      </Typography>
                      <Select
                        displayEmpty
                        labelId="statusLable"
                        id="statusSelect"
                        variant="outlined"
                        className={classes.select}
                        value={selectedServiceType ? selectedServiceType : ""}
                        onChange={handleServiceTypeChange}
                        // textToCopy
                        style={{
                          // paddingBlock: 20,
                          width: "300px",
                        }}
                      >
                        <MenuItem value="">Select</MenuItem>
                        {serviceType.map((option) => {
                          return (
                            <MenuItem value={option.text} key={option.id}>
                              {option.text}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </Grid>
                    <Grid item xs={6} sm={3}>
                      <Typography variant="h6">
                        <InputLabel className={classes.lableColor}>
                          Discount Amount
                          {/* <span
                          style={{
                              color: "red",
                              fontSize: "1.2rem",
                              marginLeft: "0.2rem",

                          }}
                      >
                          *
                      </span> */}
                        </InputLabel>
                      </Typography>
                      <TextField
                        variant="outlined"
                        value={selectedDiscountAmount}
                        // value={assestType}
                        //   name={di}
                        onChange={(e) => {
                          setSelectedDiscountAmount(e.target.value);
                        }}
                        //   disabled={question.disable}
                        disabled={disableDiscountAmount}
                        style={{
                          // marginLeft: '25px',
                          width: "300px",
                        }}
                      />
                    </Grid>
                  </>
                ) : (
                  ""
                )}
              </>
            )}
          </>
        </>

        <div item xs={2} sm={2}>
          {localStorage.getItem("empRole") === "CTO" ? (
            <Button
              onClick={urlToClipboard}
              variant="contained"
              color="primary"
              style={{ marginTop: 17 }}
            >
              Create
            </Button>
          ) : (
            <Button
              onClick={textToCopy}
              variant="contained"
              color="primary"
              // style={{ marginTop: 40 }}
            >
              Copy To Clipboard{" "}
            </Button>
          )}
        </div>
      </Grid>
      <h1>
        {showurl
          ? localStorage.getItem("empRole") === "MF Manager" ||
            localStorage.getItem("empRole") === "MF Executive"
            ? urlToCopy
            : ""
          : ""}
      </h1>
      {showurl && localStorage.getItem("empRole") === "CTO" ? (
        <h1>
          {urlToCopy}{" "}
          <>
            <span
              class="material-symbols-outlined"
              onClick={copyTheLinkAfterShowing}
            >
              content_copy
            </span>
          </>
        </h1>
      ) : (
        ""
      )}
    </>
  );
}
